<template>
  <div class="header__user-nav">
    <router-link :to="{ name: 'UserProfile' }" class="user-nav__name">{{
      avatarText
    }}</router-link>
    <dropdown-menu position="bottom-left" cssClass="user-nav__dropdown">
      <svg
        slot="dropdown-menu__button"
        class="icon--dots"
        width="16"
        height="16"
      >
        <use xlink:href="#dots" />
      </svg>
      <div slot="dropdown-menu__list">
        <router-link
          :to="{ name: 'UserProfile' }"
          class="dropdown-menu__item _user-name"
        >Профиль пользователя</router-link
        >
        <router-link
          :to="{ name: 'UserAppSettings' }"
          class="dropdown-menu__item"
        >
          Настройки приложения
        </router-link>
        <a :href="userManualPath" target="_blank" class="dropdown-menu__item"
        >Руководство пользователя</a
        >
        <a
          href="#"
          class="dropdown-menu__item dropdown-menu__divider"
          @click.prevent="logout"
        >Выйти</a
        >
      </div>
    </dropdown-menu>
  </div>
</template>

<script>
import DropdownMenu from '@@/shared/DropdownMenu';

export default {
  components: {
    DropdownMenu
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    avatarText() {
      return this.user.name[0] + this.user.surname[0];
    },
    userManualPath() {
      return `${location.protocol}//${
        location.host
      }${__BASE_URL__}NormaCS4.x_User_Manual.pdf`;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('userLogout');
    }
  }
};
</script>
